import React, { Component, Suspense, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useImmer } from 'use-immer';
import CasesRecieved from '../../controls/charts/CasesRecieved';
import { AdminMetricsService } from '../../services';
import DataPoint from '../metrics/DataPoint';
import moment from 'moment';
import CompletedCases from '../../controls/charts/CompletedCases';
import TatAverages from '../../controls/charts/TatAverages';
import { ConditionalRender } from '../../controls/formControls';
import Select from 'react-select';
import AvgTatByService from '../../controls/charts/AvgTatByService';

const AdminDashboard = (props) => {
    //const [userAccountId, setUserAccountId] = useImmer(0);
    //const [userRoleId, setUserRoleId] = useImmer(0);
    //const [userService, setUserService] = useState();
    //const [canEdit, setCanEdit] = useState(false);
    const [metrics, setMetrics] = useImmer(undefined);
    const [refData, setRefData] = useImmer({});
    const [startOfWeek, setStartOfWeek] = useImmer('');
    const [endOfWeek, setEndOfWeek] = useImmer('');
    const [weekText, setWeekText] = useImmer('');
    const [filter, setFilter] = useImmer({ accountId: [], queueId: [], assignedToId: [], fetchRefData: true });
    const [selectedFilters, setSelectedFilters] = useImmer({ accountId: [], queueId: [], assignedToId: [] });


    useEffect(() => {
        getMetrics();
        setUpDates();
    }, []);

    useEffect(() => {
        if (!filter.fetchRefData) {
            getMetrics();
        }
    }, [filter.accountId, filter.queueId, filter.assignedToId])

    const setUpDates = () => {
        let currDate = new Date();
        let sow = moment(currDate).startOf('week').add(1, "days").format('M/D');
        let eow = moment(currDate).endOf('week').add(1, "days").format('M/D');
        let week = `Week ${sow}-${eow}`;
        setStartOfWeek(sow);
        setEndOfWeek(eow);
        setWeekText(week);
    }

    const getMetrics = async () => {
        const metricsService = new AdminMetricsService();
        const callResult = await metricsService.getEventMetricsAdminDashboard(filter.accountId, filter.queueId, filter.assignedToId[0], filter.fetchRefData);
        if (callResult.result) {
            var vm = callResult.model;
            if (vm.referenceData) {
                setRefData(vm.referenceData);
            }
            delete vm.referenceData;
            setMetrics(vm);
            setFilter(draft => {
                draft.fetchRefData = false;
            })
        }
    }

    const handleChange = (selected, propName) => {
        var localSelected = selected.filter(x => !filter[propName].includes(x.value));
        setFilter(draft => {
            draft[propName] = localSelected.map(x => parseInt(x.value))
        })
        setSelectedFilters(draft => {
            draft[propName] = localSelected;
        })
    };

    return (

        <Container>
            <ConditionalRender visible={metrics != undefined && metrics != null}>
                <Row style={{ marginBottom: "0.5rem" }}>
                    <ConditionalRender visible={refData?.queueRefData?.length > 1}>
                        <Col md={4}>
                            <Select
                                options={refData?.queueRefData}
                                name="queueId"
                                isDisabled={filter.assignedToId.length || filter.accountId.length}
                                isMulti={true}
                                isSearchable={true}
                                clearable={true}
                                classNamePrefix="search-select"
                                placeholder="Select Queue..."
                                value={selectedFilters.queueId}
                                onChange={(selected, action) => {
                                    handleChange(selected, "queueId");
                                }}
                            />
                            {/*<br />*/}
                            {/*{JSON.stringify(filter.queueId, undefined, 2)}<br />*/}
                            {/*{JSON.stringify(selectedFilters.queueId, undefined, 2)}*/}
                        </Col>
                    </ConditionalRender>
                    <ConditionalRender visible={refData?.accountsRefData?.length > 1}>
                        <Col md={4}>
                            <Select
                                options={refData?.accountsRefData}
                                name="accountId"
                                isDisabled={filter.assignedToId.length || filter.queueId.length}
                                isMulti={true}
                                isSearchable={true}
                                clearable={true}
                                classNamePrefix="search-select"
                                placeholder="Select Account..."
                                value={selectedFilters.accountId}
                                onChange={(selected, action) => {
                                    handleChange(selected, "accountId");
                                }}
                            />
                            {/*<br />*/}
                            {/*{JSON.stringify(filter.accountId, undefined, 2)}<br />*/}
                            {/*{JSON.stringify(selectedFilters.accountId, undefined, 2)}*/}
                        </Col>
                    </ConditionalRender>
                    <ConditionalRender visible={refData?.assignedToRefData?.length > 1}>
                        <Col md={4}>
                            <Select
                                options={refData?.assignedToRefData}
                                name="assignedToId"
                                isDisabled={filter.queueId.length || filter.accountId.length}
                                isMulti={true}
                                isSearchable={true}
                                clearable={true}
                                classNamePrefix="search-select"
                                placeholder="Select Assigned User..."
                                value={selectedFilters.assignedToId}
                                onChange={(selected, action) => {
                                    handleChange(selected, "assignedToId");
                                }}
                            />
                            {/*<br />*/}
                            {/*{JSON.stringify(filter.assignedToId, undefined, 2)}<br />*/}
                            {/*{JSON.stringify(selectedFilters.assignedToId, undefined, 2)}*/}
                        </Col>
                    </ConditionalRender>
                </Row>
                <Row>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="Received"
                            dataPoint={metrics?.received?.data ?? 0}
                            dataStyle={{ fontSize: "4rem" }}
                            desc={metrics?.received?.dateFrom + ' - ' + metrics?.received?.dateTo} />
                    </Col>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="Completed"
                            dataPoint={metrics?.completed?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc={metrics?.completed?.dateFrom + ' - ' + metrics?.completed?.dateTo} />
                    </Col>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="Cancelled"
                            dataPoint={metrics?.cancelled?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc={metrics?.cancelled?.dateFrom + ' - ' + metrics?.cancelled?.dateTo} />
                    </Col>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="In Progress"
                            dataPoint={metrics?.inProgress?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc="Total" />
                    </Col>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="Not Started"
                            dataPoint={metrics?.notStarted?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc="Total" />
                    </Col>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="On Hold"
                            dataPoint={metrics?.onHold?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc="Total" />
                    </Col>

                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="Past Due"
                            dataPoint={metrics?.pastDue?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc="Total" />
                    </Col>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="Comp / Day"
                            dataPoint={metrics?.avgCompletedPerBizDay?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc={metrics?.avgCompletedPerBizDay?.dateFrom + ' - ' + metrics?.avgCompletedPerBizDay?.dateTo} />
                        {/*onClick={() => window.open("http://www.yahoo.com", '_blank').focus()}*/}
                    </Col>
                    <Col md={2} className="data-point-parent">
                        <DataPoint
                            title="Avg Hold Time"
                            dataPoint={metrics?.avgOnHoldTime?.data}
                            dataStyle={{ fontSize: "4rem" }}
                            desc={metrics?.avgOnHoldTime?.dateFrom + ' - ' + metrics?.avgOnHoldTime?.dateTo} />
                        {/*onClick={() => window.open("http://www.yahoo.com", '_blank').focus()}*/}
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} className="chart-parent">
                        <CompletedCases data={metrics?.weeklyStats.data} />
                    </Col>
                    <Col lg={6} className="chart-parent">
                        <TatAverages chartData={metrics?.tatMetrics} />
                    </Col>
                </Row>
                <Row>

                </Row>
            </ConditionalRender>
            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <pre>*/}
            {/*            {JSON.stringify(metrics?.avgTatByServiceType, undefined, 2) }*/}
            {/*            {JSON.stringify(refData, undefined, 2)}*/}
            {/*            {JSON.stringify(metrics, undefined, 2)}*/}
            {/*        </pre>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
        </Container>
        //<Card>
        //    <Card.Header className="d-flex align-items-center">
        //        <div className="mr-auto" >AdminDashboard</div>
        //        <div className="card-btn-group">
        //        </div>
        //    </Card.Header>
        //    <Card.Body>
        //        {/* <CasesRecieved /> */}

        //        <div>
        //            <pre>
        //                {JSON.stringify(metrics, null)}
        //            </pre>
        //        </div>
        //    </Card.Body>
        //</Card>
    );
}

//class AdminDashboard extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = { queues: [{ codingEvents: [] }] };
//    }

//    render() {
//        return (
//            <Card>
//                <Card.Header className="d-flex align-items-center">
//                    <div className="mr-auto" >AdminDashboard</div>
//                    <div className="card-btn-group">
//                    </div>
//                </Card.Header>
//                <Card.Body>
//                    {/* <CasesRecieved /> */}
//                    <div>AdminDashboard</div>
//                </Card.Body>
//            </Card>
//        );
//    }

//}

export default AdminDashboard;